import { useMemo } from "react";

export type EngagementBreakdownItem = {
  clicked: number;
  label: string;
  percentage: number;
  sent: number;
};

type EngagementBreakdownSummary = {
  total: number;
  sortedBreakdown: EngagementBreakdownItem[];
};

export const useEngagementBreakdownSummary = (
  breakdown: EngagementBreakdownItem[],
): EngagementBreakdownSummary =>
  useMemo(() => {
    const firstItem = breakdown[0];

    if (firstItem === undefined) throw new Error("Engagement breakdown data cannot be empty");

    return {
      total: breakdown.reduce((total, item) => total + item.percentage, 0),
      sortedBreakdown: [...breakdown].sort(
        (a, b) => b.percentage - a.percentage || a.sent - b.sent,
      ),
    };
  }, [breakdown]);
